import PropTypes from 'prop-types';
import styles from './Text.module.css';

/**
 * Text - Body text component for paragraphs and inline content
 * Polymorphic component that can render as different elements
 */
export function Text({
  children,
  as: Component = 'p',
  size = 'base',
  weight = 'normal',
  color = 'primary',
  align = 'left',
  leading = 'normal',
  truncate = false,
  className = '',
  ...props
}) {
  const classNames = [
    styles.text,
    styles[size],
    styles[weight],
    styles[color],
    styles[align],
    styles[leading],
    truncate && styles.truncate,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classNames} {...props}>
      {children}
    </Component>
  );
}

Text.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.elementType,
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl']),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold', 'bold']),
  color: PropTypes.oneOf(['primary', 'secondary', 'muted', 'cyan', 'lime']),
  align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
  leading: PropTypes.oneOf(['none', 'tight', 'snug', 'normal', 'relaxed', 'loose']),
  truncate: PropTypes.bool,
  className: PropTypes.string,
};

export default Text;
